import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            
            <p className="home-about-body">
            I bring hands-on expertise in cutting-edge technologies such as <i><b className="purple">React, Node.js, Express</b></i>.
              <br />
              <br />My skills extend to database management, including 
              <i>
                <b className="purple"> MongoDB and PostgreSQL. </b>
              </i>
              <br />I am also adept at enhancing project functionality with tools like 
              <i>
                <b className="purple"> Redux, GraphQL, SASS. </b> 
              </i>
              <br />
              <br />
              I am currently seeking new job opportunities and
                ready for new challenges. &nbsp;
              <br />
              <br />
              I enjoy reading books in my free time. &nbsp;
              <br />
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" style={{ width: '60%', height: '60%' }}/>
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">contact </span> me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Alpattex"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/a-rabea/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
